import React, { useState, useEffect } from 'react';
import { Navigate, NavLink, useLocation } from 'react-router-dom';
import ManageProducts from '../components/ShipturtleProducts/ManageProducts';
import AdminApprovalQueue from '../components/ShipturtleProducts/AdminApprovalQueue';
import AddProductsPage from '../components/ShipturtleProducts/AddProductsPage';
import UnlistedProducts from '../components/ShipturtleProducts/UnlistedProducts';
import {
  PRODUCT_SECTIONS,
  productsPath,
  resolveLegacyProductsUrl,
  useProductsRouteParams,
} from '../components/ShipturtleProducts/productsNavigation';
import styles from './ShipturtleProducts.module.css';
import { getCurrentUserRole } from '../services/shipturtleApi';

// Section and child screen both come from the URL (see productsNavigation.js),
// so browser Back/Forward, refresh and shared links all land on the same screen.
function ShipturtleProducts() {
  const location = useLocation();
  const { section, child } = useProductsRouteParams();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchRole = async () => {
      try {
        const roleData = await getCurrentUserRole();
        if (isMounted) {
          setUserRole(roleData?.role || 'vendor');
        }
      } catch (error) {
        if (isMounted) {
          setUserRole('vendor');
        }
      }
    };

    fetchRole();

    return () => {
      isMounted = false;
    };
  }, []);

  const legacyTarget = resolveLegacyProductsUrl(location.search, location.hash);
  if (legacyTarget) {
    return <Navigate to={legacyTarget} replace state={location.state} />;
  }
  if (!PRODUCT_SECTIONS.includes(section)) {
    return <Navigate to={productsPath('manage')} replace state={location.state} />;
  }

  const tabs = [
    { section: 'manage', label: 'Manage Products' },
    { section: 'pending', label: userRole === 'admin' ? 'Approve Products' : 'Pending Approval Products' },
    { section: 'unlisted', label: 'Unlisted Products' },
    { section: 'add', label: 'Add Products' },
  ];

  return (
    <div className={styles.terminalPageRoot}>
      <div className={styles.subNav}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.section}
            to={productsPath(tab.section)}
            className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      {/* Content area */}
      <div className={styles.content}>
        {section === 'manage' && (
          <div className={styles.tabContent}>
            <ManageProducts />
          </div>
        )}

        {section === 'pending' && (
          <div className={styles.tabContent}>
            <AdminApprovalQueue />
          </div>
        )}

        {section === 'unlisted' && (
          <div className={styles.tabContent}>
            <UnlistedProducts />
          </div>
        )}

        {section === 'add' && (
          <div className={styles.tabContent}>
            <AddProductsPage method={child} />
          </div>
        )}
      </div>
    </div>
  );
}

export default ShipturtleProducts;
